export const formatTankLabel = (label) => {
    return label
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const getInitials = (value) => {
    if (!value) return '';
  
    const names = value.trim().split(' ');
    const initials = names.slice(0, 2).map(name => name[0].toUpperCase());
  
    return initials.join('');
  };
  